import React, { useState, useEffect, useCallback } from 'react';
import { Switch } from 'antd';
import styled from 'styled-components';

interface SwitchAndInputProps {
  fieldValue: any;
  setFieldsValue: (values: any) => void;
  fieldName: string;
  switchOffDefaultValue: any;
  switchOnDefaultValue: any;
  children: React.ReactNode;
  checkedName: string;
  unCheckedName: string;
  compact?: boolean;
}

const SwitchAndInput = ({
  fieldValue,
  setFieldsValue,
  fieldName,
  switchOffDefaultValue,
  switchOnDefaultValue,
  children,
  checkedName,
  unCheckedName,
  compact = false,
}: SwitchAndInputProps) => {
  const [switchChecked, setSwitch] = useState(!fieldValue);

  useEffect(() => {
    setSwitch(!fieldValue);
  }, [fieldValue]);

  const setSwitchChecked = useCallback(() => {
    if (!switchChecked) {
      setFieldsValue({ [fieldName]: switchOffDefaultValue });
    } else {
      setFieldsValue({ [fieldName]: switchOnDefaultValue });
    }
    setSwitch(!switchChecked);
  }, [fieldName, setFieldsValue, switchChecked, switchOffDefaultValue, switchOnDefaultValue]);

  return (
    <SwitchAndInputWrapper $compact={compact}>
      <div className="switchWrapper">
        <Switch
          checkedChildren={checkedName}
          unCheckedChildren={unCheckedName}
          checked={switchChecked}
          onChange={setSwitchChecked}
        />
      </div>
      <div
        className="inputWrapper"
        style={{
          display: switchChecked ? 'none' : undefined,
        }}
      >
        {children}
      </div>
    </SwitchAndInputWrapper>
  );
};

export default SwitchAndInput;

const SwitchAndInputWrapper = styled.div<{ $compact?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: ${({ $compact }) => ($compact ? 'stretch' : 'center')};
  gap: ${({ $compact }) => ($compact ? '12px' : '0')};

  .switchWrapper {
    width: ${({ $compact }) => ($compact ? 'auto' : '8rem')};
    margin: ${({ $compact }) => ($compact ? '0' : '2rem 0')};
    flex-shrink: 0;
    display: flex;
    align-items: center;
  }

  .inputWrapper {
    flex: ${({ $compact }) => ($compact ? '1' : 'initial')};
    min-width: ${({ $compact }) => ($compact ? '0' : 'auto')};
    display: ${({ $compact }) => ($compact ? 'flex' : 'block')};
    align-items: center;

    .ant-form-item {
      margin-bottom: 0;
      width: 100%;
    }
  }

  .ant-switch {
    height: 30px;
    line-height: 30px;
  }
  .ant-switch-handle {
    top: 6px;
  }
`;
